import { useCallback, useEffect, useState } from 'react';
import { useTelegramAccountsStore } from '../stores/telegramAccounts.store';
import { UserAuth } from '../../middleware/UserContext/UserContext.middleware';

export function useTelegramAccounts(options: { perPage?: number } = {}) {
  const perPage = options.perPage ?? 12;
  const { currentUser } = UserAuth();
  const { items, pagination, isLoading, error, search, list, setSearch, reset } = useTelegramAccountsStore();
  const [hasMore, setHasMore] = useState(false);

  useEffect(() => { setHasMore(pagination.page * pagination.perPage < (pagination.total || 0)); }, [pagination]);

  const load = useCallback((page: number, q?: string) => { if (currentUser) return list(currentUser, page, perPage, q); return Promise.resolve(); }, [currentUser, list, perPage]);
  const loadInitial = useCallback(() => load(1, search), [load, search]);
  const loadMore = useCallback(() => load(pagination.page + 1, search), [load, pagination.page, search]);
  const refresh = useCallback(() => load(1, search), [load, search]);
  const onSearch = useCallback((q: string) => { setSearch(q); return load(1, q); }, [setSearch, load]);

  useEffect(() => { return () => { reset(); }; }, [reset]);

  const initialLoading = isLoading && items.length === 0;

  return { items, pagination, isLoading, initialLoading, error, search, load, loadInitial, loadMore, refresh, onSearch, hasMore };
}
